// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__JVIZ1","inputWrap":"styles_inputWrap__1bBIA","input":"styles_input__1hvWO"};